module.exports = __webpack_public_path__ + "static/media/Joking Together.5e7cffd4.jpg";